import React from 'react';
import { styled, css } from '@mui/system';
import { useTheme } from '@mui/material/styles';

import Paper from '@mui/material/Paper';
import Modal from '@mui/material/Modal';
// import {Modal as BaseModal} from '@mui/base/Modal';
import Popover from '@mui/material/Popover';
// import Backdrop from '@mui/material/Backdrop';
import clsx from 'clsx';
import Bs4Kartoteka from '../Bs4Kartoteka'
import { SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';

// const Modal = styled(BaseModal)`
//   position: fixed;
//   z-index: 1300;
//   inset: 0;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

const Backdrop = React.forwardRef((props, ref) => {
  const { open, className, ...other } = props;
  return (
    <div
      className={clsx({ 'base-Backdrop-open': open }, className)}
      ref={ref}
      {...other}
    />
  );
});

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: transparent;
`;

export const  Bs4ModalTopCenter = (props) => {
  const {children, sx, elevation, bs4KartotekaId, ...other} = props;  

  const theme = useTheme()  
  const [visibility, setVisibility] = React.useState(Bs4Kartoteka.get(props.bs4KartotekaId)?.visibility || true);
  
  React.useEffect(() => {  
    Bs4Kartoteka.get(bs4KartotekaId)?.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);
    return () => Bs4Kartoteka.get(bs4KartotekaId)?.off(setVisibility);
  }, [bs4KartotekaId, setVisibility]);

  return (
    <Modal
      sx={{
        alignItems: 'flex-start',
        ...sx,
        visibility: visibility ? Bs4Kartoteka.VISIBILITY_VISIBLE : Bs4Kartoteka.VISIBILITY_HIDDEN,
      }}            
      {...other}      
      slots={{ backdrop: StyledBackdrop }}
    >
      <Paper 
        elevation={elevation || 10}        
        sx={{
          minWidth: 3, 
          minHeight: 3,
          p: 1, 
          borderRadius: theme.shape.borderRadius+'px',
          // backgroundColor: theme.Bs4.backgroundColor,
        }}
      >
        {children}
      </Paper>
    </Modal>
  )
}

export const  Bs4Popover = (props) => {
  const {children, sx, elevation, bs4KartotekaId, onOpen, ...other} = props;  
  // const [anchorEl, setAnchorEl] = React.useState(null);

  const [visibility, setVisibility] = React.useState(Bs4Kartoteka.get(props.bs4KartotekaId)?.visibility || true);
  
  React.useEffect(() => {
    if (props.open && onOpen) onOpen();
  }, [props.open])

  React.useEffect(() => {  
    Bs4Kartoteka.get(bs4KartotekaId)?.on(Bs4Kartoteka.CHANGE_VISIBILITY, setVisibility);
    return () => Bs4Kartoteka.get(bs4KartotekaId)?.off(setVisibility);
  }, [bs4KartotekaId, setVisibility]);

  return (
    <Popover
      sx={{ ...sx, visibility: visibility ? Bs4Kartoteka.VISIBILITY_VISIBLE : Bs4Kartoteka.VISIBILITY_HIDDEN}}
      {...other}
    >
      {children}
    </Popover>
  )
}

export const  Bs4PopoverModal = (props) => {
  const {children, sx, elevation, bs4KartotekaId, ...other} = props;  
  const smallScreen = React.useContext(SmallScreenContext);

  React.useEffect(() => {
    if (props.open && props.onOpen) props.onOpen();
  }, [props.open])

  if (smallScreen) return (
    <Bs4ModalTopCenter
      bs4KartotekaId={bs4KartotekaId}
      open={props.open}
      onClose={props.onClose}
    >
      {children}
    </Bs4ModalTopCenter>
  )

  return (
    <Bs4Popover
      {...props}    
    >
      {children}
    </Bs4Popover>
  )
}
export default Bs4ModalTopCenter;
  
  